// theme.js
export const colors = {
    primary: '#181D23',
    secondary: '#F2B624',
    alternative: '#18AEBF',
    background: '#DADADA',
    text: '#333',
  };
  